module.exports = __webpack_public_path__ + "themes/fq/sprite/green-button.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/green-button.json
// module id = 98
// module chunks = d-game